import { LegalPageLayout } from './LegalPageLayout';

export default function Datenschutz() {
  return (
    <LegalPageLayout title="Datenschutzerklärung" lastUpdated="Februar 2026" testId="datenschutz-page">
      <p className="italic text-slate-500">
        Hier wird die Datenschutzerklärung eingefügt. Die folgenden Angaben sind Platzhalter und müssen vor dem
        produktiven Einsatz durch den Betreiber mit einer auf die tatsächliche Datenverarbeitung zugeschnittenen
        Erklärung ersetzt werden.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-3">1. Verantwortlicher</h2>
      <p>
        Verantwortlicher im Sinne der DSGVO ist:<br />
        [Name / Firma]<br />
        [Anschrift]<br />
        E-Mail: <a href="mailto:datenschutz@immo-verwaltung.online" className="text-violet-700 hover:underline">datenschutz@immo-verwaltung.online</a>
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">2. Erhebung und Verarbeitung personenbezogener Daten</h2>
      <p>
        Wir erheben und verarbeiten personenbezogene Daten ausschließlich zum Zweck der Bereitstellung der
        Immobilienverwaltungssoftware. Dazu gehören insbesondere:
      </p>
      <ul className="list-disc list-inside space-y-1 mt-2">
        <li>Stammdaten von Vermietern, Mietern und Mandanten (Name, Anschrift, E-Mail)</li>
        <li>Beleg- und Abrechnungsdaten (hochgeladene Rechnungen, Kostenstellen)</li>
        <li>Nutzungsdaten (Login-Zeitpunkte, IP-Adressen, Audit-Log-Ereignisse) zur Gewährleistung der IT-Sicherheit</li>
      </ul>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">3. Rechtsgrundlage</h2>
      <p>
        Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung), lit. c DSGVO
        (rechtliche Verpflichtung – z.B. handels- und steuerrechtliche Aufbewahrungspflichten) sowie lit. f DSGVO
        (berechtigtes Interesse – IT-Sicherheit / Audit-Log).
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">4. Auftragsverarbeitung &amp; KI-Nutzung</h2>
      <p>
        Für die optionale KI-gestützte Beleg-Kategorisierung nutzen wir den <strong>IONOS AI Model Hub</strong>
        (Rechenzentrum Frankfurt, Deutschland). Vor jeder Anfrage werden personenbezogene Daten
        (Adressen, IBANs, Steuernummern) lokal anonymisiert; Adress-Auflösungen bleiben ausschließlich auf
        unserem Server in Deutschland.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">5. Speicherdauer</h2>
      <p>
        Belege und Buchhaltungsdaten werden gemäß § 147 AO 10 Jahre aufbewahrt. Audit-Log-Einträge zu Login-
        und System-Ereignissen werden nach 90 Tagen automatisch gelöscht.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">6. Ihre Rechte</h2>
      <p>Sie haben jederzeit das Recht auf:</p>
      <ul className="list-disc list-inside space-y-1 mt-2">
        <li>Auskunft (Art. 15 DSGVO)</li>
        <li>Berichtigung (Art. 16 DSGVO)</li>
        <li>Löschung (Art. 17 DSGVO)</li>
        <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Widerspruch (Art. 21 DSGVO)</li>
        <li>Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)</li>
      </ul>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">7. Cookies &amp; Sitzungs-Token</h2>
      <p>
        Wir verwenden technisch notwendige Cookies (Sitzungs-Token, JWT) ausschließlich für den Login. Es findet
        kein Tracking und keine Auswertung durch Drittanbieter statt.
      </p>

      <p className="italic text-slate-400 text-xs mt-8">
        Hinweis: Dies ist ein automatisch generierter Platzhalter. Vor produktivem Einsatz unbedingt von einem
        Datenschutzbeauftragten / Anwalt prüfen lassen.
      </p>
    </LegalPageLayout>
  );
}
